import axios from "axios"

export function updateBlacklistedAdCategories(token, body) {
    return axios.post(process.env.REACT_APP_API_URL + `/updateBlacklistedAdCategories`, body, {
        headers: {
            'Authorization': `${token}`
        }
    });
}
